import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import axiosInstance from "../axiosInstance";

function Sidebar() {
    const location = useLocation();
    const [activeMenu, setActiveMenu] = useState(null);
    const [permissions, setPermissions] = useState({});

    const toggleMenu = (menu) => {
        setActiveMenu(activeMenu === menu ? null : menu);
    };

    const isActive = (path) => location.pathname === path ? "active" : "";

    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const userId = localStorage.getItem("user_id");
                if (!userId) return;
                const response = await axiosInstance.get(`/permission/${userId}`);
                if (response.data.success) {
                    const perms = {};
                    response.data.data.forEach((item) => {
                        perms[item.module_name] = item.can_view;
                    });
                    setPermissions(perms);
                }
            } catch (error) {
                console.error("Failed to fetch permissions:", error);
            }
        };
        fetchPermissions();
    }, []);

    return (
        <div className="sidebar" id="sidebar">
            <div className="sidebar-inner slimscroll">
                <div id="sidebar-menu" className="sidebar-menu">
                    <ul className="sidebar-vertical">

                        {/* ── Dashboard ── */}
                        {permissions.dashboard && (
                            <li className={`submenu ${activeMenu === "dashboard" ? "subdrop" : ""}`}>
                                <a href="#" onClick={(e) => { e.preventDefault(); toggleMenu("dashboard"); }}>
                                    <i className="fe fe-home"></i>
                                    <span>Dashboard</span>
                                    <span className="menu-arrow"></span>
                                </a>
                                <ul style={{ display: activeMenu === "dashboard" ? "block" : "none" }}>
                                    <li>
                                        <Link to="/dashboard" className={isActive("/dashboard")}>
                                            Admin Dashboard
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/sales-dashboard" className={isActive("/sales-dashboard")}>
                                            Sales Dashboard
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                        )}

                        {/* ── WhatsApp ── */}
                        {permissions.billing && (
                            <>
                                <li className="menu-title"><span>WhatsApp</span></li>
                                <li>
                                    <Link to="/chat" className={isActive("/chat")}>
                                        <i className="fe fe-message-circle"></i>
                                        <span>Chat</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/wa-contacts" className={isActive("/wa-contacts")}>
                                        <i className="fe fe-user-check"></i>
                                        <span>WA Contacts</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/broadcast" className={isActive("/broadcast")}>
                                        <i className="fe fe-radio"></i>
                                        <span>Broadcast</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/templates" className={isActive("/templates")}>
                                        <i className="fe fe-file-text"></i>
                                        <span>Templates</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/broadcast-report" className={isActive("/broadcast-report")}>
                                        <i className="fe fe-bar-chart-2"></i>
                                        <span>Broadcast Report</span>
                                    </Link>
                                </li>
                            </>
                        )}

                        {/* ── CRM ── */}
                        {(permissions.lead || permissions.account || permissions.contact || permissions.users) && (
                            <>
                                <li className="menu-title"><span>CRM</span></li>
                                {permissions.lead && (
                                    <li>
                                        <Link to="/lead" className={isActive("/lead")}>
                                            <i className="fe fe-trending-up"></i>
                                            <span>Leads</span>
                                        </Link>
                                    </li>
                                )}
                                {permissions.account && (
                                    <li>
                                        <Link to="/account" className={isActive("/account")}>
                                            <i className="fe fe-briefcase"></i>
                                            <span>Accounts</span>
                                        </Link>
                                    </li>
                                )}
                                {permissions.contact && (
                                    <li>
                                        <Link to="/contact" className={isActive("/contact")}>
                                            <i className="fe fe-users"></i>
                                            <span>Contacts</span>
                                        </Link>
                                    </li>
                                )}
                                {permissions.users && (
                                    <li>
                                        <Link to="/user" className={isActive("/user")}>
                                            <i className="fe fe-user"></i>
                                            <span>Users</span>
                                        </Link>
                                    </li>
                                )}
                            </>
                        )}

                        {/* ── Finance ── */}
                        {permissions.billing && (
                            <>
                                <li className="menu-title"><span>Finance</span></li>
                                <li>
                                    <Link to="/quotation" className={isActive("/quotation")}>
                                        <i className="fe fe-file-text"></i>
                                        <span>Create Document</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/documents" className={isActive("/documents")}>
                                        <i className="fe fe-folder"></i>
                                        <span>Documents</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/billing" className={isActive("/billing")}>
                                        <i className="fe fe-credit-card"></i>
                                        <span>Billing</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/gstbilling" className={isActive("/gstbilling")}>
                                        <i className="fe fe-file"></i>
                                        <span>GST Billing</span>
                                    </Link>
                                </li>
                            </>
                        )}

                        {/* ── Operations ── */}
                        {(permissions.employee || permissions.product || permissions.customer) && (
                            <>
                                <li className="menu-title"><span>Operations</span></li>
                                {permissions.employee && (
                                    <li>
                                        <Link to="/employee" className={isActive("/employee")}>
                                            <i className="fe fe-user-plus"></i>
                                            <span>Employees</span>
                                        </Link>
                                    </li>
                                )}
                                {permissions.product && (
                                    <li>
                                        <Link to="/product" className={isActive("/product")}>
                                            <i className="fe fe-package"></i>
                                            <span>Products</span>
                                        </Link>
                                    </li>
                                )}
                                {permissions.customer && (
                                    <li>
                                        <Link to="/customer" className={isActive("/customer")}>
                                            <i className="fe fe-shopping-bag"></i>
                                            <span>Customers</span>
                                        </Link>
                                    </li>
                                )}
                            </>
                        )}

                        {/* ── Settings ── */}
                        {permissions.settings && (
                            <>
                                <li className="menu-title"><span>Settings</span></li>
                                <li>
                                    <Link to="/settings" className={isActive("/settings")}>
                                        <i className="fe fe-settings"></i>
                                        <span>Settings</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/company-settings" className={isActive("/company-settings")}>
                                        <i className="fe fe-sliders"></i>
                                        <span>Company Settings</span>
                                    </Link>
                                </li>
                            </>
                        )}

                        {/* ── Location ── */}
                        {permissions.countries && (
                            <>
                                <li className="menu-title"><span>Location</span></li>
                                <li>
                                    <Link to="/countries" className={isActive("/countries")}>
                                        <i className="fe fe-globe"></i>
                                        <span>Countries</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/states" className={isActive("/states")}>
                                        <i className="fe fe-map"></i>
                                        <span>States</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/cities" className={isActive("/cities")}>
                                        <i className="fe fe-map-pin"></i>
                                        <span>Cities</span>
                                    </Link>
                                </li>
                            </>
                        )}

                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Sidebar;
